import { topicCards } from '@/mocks/gossipData';
import { fmtWan } from './format';

const circleStyle: Record<string, string> = {
  连续剧: 'bg-accent-100 text-accent-800',
  深扒: 'bg-secondary-100 text-secondary-800',
  辟谣: 'bg-primary-100 text-primary-800',
  比价: 'bg-secondary-100 text-secondary-800',
  反转: 'bg-accent-100 text-accent-800',
};

export default function TopicGrid() {
  return (
    <section id="topic" className="bg-background-100">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
              <i className="ri-stack-line" />
              瓜棚追更
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              大小卡混排 · 追更不迷路
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              把同一话题的来龙去脉整理成专题，大头卡讲全貌，小卡讲切片，混着摆也清楚。
            </p>
          </div>
          <a href="#fresh" className="text-xs text-foreground-500 hover:text-primary-700 cursor-pointer whitespace-nowrap">
            查看更多专题 →
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-12">
          {topicCards.map((t, i) => {
            const isLg = t.size === 'lg';
            return (
              <article
                key={t.id}
                className={`fade-up flex flex-col justify-between rounded-2xl border border-background-200 p-5 transition-colors hover:border-primary-300 md:p-6 ${
                  isLg ? 'md:col-span-7' : 'md:col-span-5'
                } ${isLg ? 'bg-white' : 'bg-background-50'}`}
                style={{ animationDelay: `${i * 70}ms` }}
              >
                <div>
                  <div className="flex flex-wrap items-center gap-2">
                    <span
                      className={`rounded-md px-2 py-0.5 text-[10px] font-semibold ${circleStyle[t.circle] ?? 'bg-secondary-100 text-secondary-800'}`}
                    >
                      {t.circle}
                    </span>
                    {t.chapters && (
                      <span className="flex items-center gap-1 text-[10px] text-primary-700">
                        <i className="ri-play-list-2-line" />
                        {t.chapters}
                      </span>
                    )}
                  </div>
                  <h3
                    className={`mt-3 font-heading font-bold leading-snug text-foreground-950 ${
                      isLg ? 'text-lg md:text-2xl' : 'text-base md:text-lg'
                    }`}
                  >
                    {t.title}
                  </h3>
                  <p
                    className={`mt-2 text-sm leading-relaxed text-foreground-600 ${
                      isLg ? '' : 'line-clamp-2'
                    }`}
                  >
                    {t.desc}
                  </p>
                </div>
                <div className="mt-5 flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1"><i className="ri-time-line" />{t.time}</span>
                  <span className="flex items-center gap-1 text-primary-700"><i className="ri-fire-line" />{fmtWan(t.heat)}</span>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}